import gql from 'graphql-tag'

const mutation = gql`mutation activation ($activationInfoInput: ActivationInfoInput!){
  activationInfo (activationInfoInput: $activationInfoInput){
    type, details {
      contractId, market, creditBalance, subBrand, tariffIdentifier, webIdentPending, retailerId
      preactivatedTariff {
        tariffIdentifier name basicFee duration { amount unit }
      }
      activatableTariffs {
        allTariffOptions {
          automaticExtension
          duration {amount unit}
          name
          notBookableWith
          phoneFlat
          price
          smsFlat
          tariffoptionId
        }
        tariffId: tariffIdentifier
        name
        basicFee
        phoneFlat
        smsFlat
        runtime { amount unit }
        tariffOptions { tariffOptionId tariffOptionName notBookableWith price duration { amount unit }
        }
      }
    }
  }
}`
export default mutation
